export default {
  title: 'Aktivitäten Log',
  errorLoading: 'Aktivitätslog konnte nicht geladen werden.',
  noDiffData: 'Die Änderungsdaten konnten nicht geladen werden.',
  applications: {
    events: 'Veranstaltungen',
    jobmarket: 'Stellenmarkt',
    articles: 'Beiträge',
    leihbar: 'LeihBar',
    modules: 'Module',
    'module-selections': 'AWPM/FWPM' // ? This key has to be like this due to the key being used to query and in the db it is saved with the hyphen
  },
  columns: {
    time: 'Zeitpunkt',
    application: 'Dienst',
    domain: 'Unterbereich',
    description: 'Beschreibung',
    action: 'Aktion',
    type: 'Verursacher',
    refId: 'Referenz Id'
  }
};
